import { formatPhone } from "../utils/phone";

export default function PhoneInput({
  name,
  value,
  onChange,
  className = "form-control",
  placeholder = "10 digits",
  required = false,
  ...rest
}) {
  const handleChange = (e) => {
    const formatted = formatPhone(e.target.value);
    onChange({
      ...e,
      target: { ...e.target, name, value: formatted },
    });
  };

  return (
    <input
      type="tel"
      name={name}
      className={className}
      value={value || ""}
      onChange={handleChange}
      placeholder={placeholder}
      inputMode="numeric"
      autoComplete="tel"
      required={required}
      maxLength={12}
      {...rest}
    />
  );
}
